export const TAKEN_COUNT = 50;
